import { closeModalGlobal, openModalGlobal, clearContent } from './modal';

export const initMap = (mapLink) => {
  clearContent();
  const mapFrame = document.createElement('IFRAME');
  mapFrame.setAttribute("allfullscreen", "allowfullscreen");
  mapFrame.setAttribute("src", mapLink);
  mapFrame.classList.add('frameTour');
  openModalGlobal(mapFrame);
}



// WEBPACK FOOTER //
// ./src/js/components/engrain-map.js